var _taggedTemplateLiteral = require("D:\\Work\\kazvabg\\dashboard-client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/taggedTemplateLiteral");

function _templateObject14() {
  var data = _taggedTemplateLiteral(["(?:[/?#]S*)?$"], ["(?:[/?#]\\S*)?$"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["(?::d{2,5})?"], ["(?::\\d{2,5})?"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["(?:.(?:[a-z\xA1-\uFFFF]{2,})).?)"], ["(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))\\.?)"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["(?:.(?:[a-z\xA1-\uFFFF0-9]-*)*[a-z\xA1-\uFFFF0-9]+)*"], ["(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["(?:(?:[a-z\xA1-\uFFFF0-9]-*)*[a-z\xA1-\uFFFF0-9]+)"], ["(?:(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["|"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["(?:.(?:[1-9]d?|1dd|2[0-4]d|25[0-4]))"], ["(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["(?:.(?:1?d{1,2}|2[0-4]d|25[0-5])){2}"], ["(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["(?:[1-9]d?|1dd|2[01]d|22[0-3])"], ["(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["(?!172.(?:1[6-9]|2d|3[0-1])(?:.d{1,3}){2})"], ["(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["(?!(?:169.254|192.168)(?:.d{1,3}){2})"], ["(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["(?:(?!(?:10|127)(?:.d{1,3}){3})"], ["(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["(?:S+(?::S*)?@)?"], ["(?:\\S+(?::\\S*)?@)?"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["^(?:(?:https?|ftp)://)"], ["^(?:(?:https?|ftp):\\/\\/)"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/* eslint-disable no-control-regex */
var _require = require('lodash'),
    isEmpty = _require.isEmpty;

var required = function required(value) {
  var val = value;

  if (Number.isInteger(value)) {
    val = value.toString();
  }

  return !isEmpty(val);
};

var length = function length(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (value) {
    return (min ? value.length > min : true) && (max ? value.length < max : true);
  } else {
    return true;
  }
};

var onlyLatinAphaNumericNoSpaces = function onlyLatinAphaNumericNoSpaces(value) {
  var acceptEmpty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (isEmpty(value)) {
    return acceptEmpty;
  } else {
    var regex = /^[a-z\d\-_]+$/i;
    var isValid = regex.test(value);
    return isValid;
  }
};
/**
 * Verifies that a single-line value is a valid url
 * @param{string} value 
 * Implements @diegoperini variant from https://mathiasbynens.be/demo/url-regex - taken from regex101 */


function isUrl(value) {
  // full test string: /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/ui;
  var regEx = new RegExp(String.raw(_templateObject()) + String.raw(_templateObject2()) + String.raw(_templateObject3()) + String.raw(_templateObject4()) + String.raw(_templateObject5()) + String.raw(_templateObject6()) + String.raw(_templateObject7()) + String.raw(_templateObject8()) + String.raw(_templateObject9()) + String.raw(_templateObject10()) + String.raw(_templateObject11()) + String.raw(_templateObject12()) + String.raw(_templateObject13()) + String.raw(_templateObject14()), 'ui');
  return regEx.test(value);
}
/**
 * Verifies that a single-line value is a valid email
 * Returns bool true if valid; false otherwise
 * @param {string} value the string to verify against
 * @param {boolean} isUnicode true if use of unicode characters is permitted; false otherwise
 * Implemented as to allow characters based on RFC5322 Section 3.4 standards and http://rumkin.com/software/email/rfc.php
 * 
  a-zA-Z0-9!#$%&'*+-/=?^_`{|}~
  . (not first or last character, doesn't appear consecutively)
  @
  domain names can only contain letters, numbers, and dashes
  *
  * Only ASCII support:
  *
  (?=[A-Z0-9@\.!#$%&'*+/=?^_`{|}~\-]{5,253}$) enforce the 254 character limit ahead; pre-check for invalid characters overall;
  ([A-Z0-9!#$%&'*+/=?^_`{|}~\-]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~\-]+)*){1,64} start with a letter or a digit; any dot must be followed by a character; max 64 characters back
  @ 
  (?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8} // no consecutive dashes or dots; max 8 sub-domains; total of 63 characters ahead;
  [A-Z]{2,63}$ // end with letters only; max 63 characters back
  *
  * Added Unicode character support at places marked with HERE: 
  * 
  /^(?=[A-Z0-9@\.!#$%&'*+/=?^_`{|}~\-HERE]{5,253}$)
  ([A-Z0-9!#$%&'*+/=?^_`{|}~\-HERE]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~\-HERE]+)*){1,64}
  @
  (?:(?=[A-Z0-9-HERE]{1,63}\.)[A-Z0-9HERE]+(?:-[A-Z0-9HERE]+)*\.){1,8}
  [A-ZHERE]{2,63}$/ui
  *
  * HERE <=> \u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}
*/


var isEmailValid = function isEmailValid(value
/*, isUnicode = false*/
) {
  var regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i; // if (isUnicode) {
  //   regex = /^(?=[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{0040}\u{002D}-\u{002F}\u{0021}\u{0023}-\u{0027}\u{002A}\u{002B}\u{003D}\u{003F}\u{005E}-\u{0060}\u{007B}-\u{007E}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]{5,253}$)([\u{0041}-\u{005A}\u{0030}-\u{0039}\u{002D}\u{002F}\u{0021}\u{0023}-\u{0027}\u{002A}\u{002B}\u{003D}\u{003F}\u{005E}-\u{0060}\u{007B}-\u{007E}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+(?:[\u{002E}][\u{0041}-\u{005A}\u{0030}-\u{0039}\u{002D}\u{002F}\u{0021}\u{0023}-\u{0027}\u{002A}\u{002B}\u{003D}\u{003F}\u{005E}-\u{0060}\u{007B}-\u{007E}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+)*){1,64}@(?:(?=[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{002D}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]{1,63}\u{002E})[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+(?:\u{002D}[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+)*\u{002E}){1,8}[\u{0041}-\u{005A}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]{2,63}$/iu;
  // } else {
  //   regex = /^(?=[A-Z0-9@.!#$%&'*+/=?^_`{|}~-]{5,253}$)([A-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~-]+)*){1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/i
  // }

  var isValid = regex.test(value);
  return isValid;
};

var isSourceValid = function isSourceValid(source) {
  return required(source) && length(source, 1, 21) && onlyLatinAphaNumericNoSpaces(source);
};

var isValidFileName = function isValidFileName(fileName) {
  return /^[a-z0-9_.@()\-\s]+$/gi.test(fileName);
};

var isStrongPassword = function isStrongPassword(password) {
  var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.{8,})/;
  return password.search(pattern) > -1 ? true : false;
};

module.exports = {
  isSourceValid: isSourceValid,
  required: required,
  length: length,
  onlyLatinAphaNumericNoSpaces: onlyLatinAphaNumericNoSpaces,
  isValidFileName: isValidFileName,
  isStrongPassword: isStrongPassword,
  isUrl: isUrl,
  isEmailValid: isEmailValid
};